import React, { useState, useEffect } from "react";

const CircleLoading = ({ handleOpen = () => {}, taskManager = null }) => {
  const [percentage, setPercentage] = useState(0);
  const [hasTasks, setHasTasks] = useState(false);

  useEffect(() => {
    if (taskManager) {
      const interval = setInterval(() => {
        try {
          const tasks = taskManager.getRunningTasks();
          if (tasks && tasks.length > 0) {
            setHasTasks(true);
            const total = tasks.reduce((sum, t) => sum + (t.progress || 0), 0);
            setPercentage(Math.floor(total / tasks.length));
          } else {
            setHasTasks(false);
            setPercentage(0);
          }
        } catch (error) {
           console.error("CircleLoading Error: ", error);
        }
      }, 500);
      return () => clearInterval(interval);
    } else {
      const values = [0, 20, 40, 60, 80, 100];
      let index = 0;
      const interval = setInterval(() => {
        setPercentage(values[index]);
        index = (index + 1) % values.length;
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [taskManager]);

  if (taskManager && !hasTasks) {
     return null;
  }


  const radius = 50;
  const strokeWidth = 5;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div
      onClick={handleOpen}
      style={{
        background: "#fff",
        border: "2px solid #F9F9F9",
        width: "53px",
        height: "53px",
        borderRadius: "50px",
        position: "absolute",
        bottom: "46px ",
        right: "16px"
      }}
    >
      <svg width="53" height="53" viewBox="0 0 120 120">
        {/* Background Circle */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="lightgray"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress Circle */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#71D071"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
          style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
        />
        {/* Progress Text */}
        <text
          x="60"
          y="65"
          fontSize="16"
          textAnchor="middle"
          fill="black"
          fontWeight="500"
          fontFamily="Helvetica, sans-serif"
        >
          {percentage}%
        </text>
      </svg>
    </div>
  );
};

export default CircleLoading;
